module.exports = __webpack_public_path__ + "img/text.a943db9e.png";